import * as Dialog from '@radix-ui/react-dialog';
import { useStore } from '@/state/store';
import { TEMPLATES } from '@/content/templates';

/** Starter-template picker (§10.8, Appendix E). Tax fields inherit the user's profile. */
export function Templates({ trigger }: { trigger?: React.ReactNode }) {
  const sofr = useStore((s) => s.sofrLatestRate);
  const taxProfile = useStore((s) => s.taxProfile);
  const loadInputs = useStore((s) => s.loadInputs);

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        {trigger ?? (
          <button type="button" className="rounded-md border border-slate-300 px-2 py-1 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800">
            Templates
          </button>
        )}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(90vw,560px)] -translate-x-1/2 -translate-y-1/2 rounded-lg border border-slate-200 bg-white p-4 shadow-xl dark:border-slate-700 dark:bg-slate-800">
          <Dialog.Title className="text-base font-semibold">Starter templates</Dialog.Title>
          <Dialog.Description className="sr-only">Load a pre-built scenario to start from.</Dialog.Description>
          <ul className="mt-3 flex flex-col gap-2">
            {TEMPLATES.map((t) => (
              <li key={t.name}>
                <Dialog.Close asChild>
                  <button
                    type="button"
                    onClick={() => loadInputs(t.build(sofr, taxProfile), t.name)}
                    className="w-full rounded border border-slate-200 p-2 text-left hover:border-sky-400 hover:bg-sky-50 dark:border-slate-700 dark:hover:bg-slate-700"
                  >
                    <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">{t.name}</div>
                    <div className="text-xs text-slate-500 dark:text-slate-400">{t.description}</div>
                  </button>
                </Dialog.Close>
              </li>
            ))}
          </ul>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
